// document.addEventListener('DOMContentLoaded', () => {
//     const letterWraps = document.querySelectorAll('.letter--wrap');
  
//     // Funktion zur Generierung einer Zufallszahl im Bereich min bis max
//     const getRandom = (min, max) => Math.random() * (max - min) + min;
  
//     // Funktion zur Prüfung, ob ein Element im Viewport ist
//     const isInViewport = (element) => {
//       const rect = element.getBoundingClientRect();
//       return (
//         rect.top >= -rect.height &&
//         rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + rect.height
//       );
//     };
  
//     // Speichert Bewegungsparameter für jeden Buchstaben
//     const letters = Array.from(letterWraps).map(wrap => {
//       const letter = wrap.querySelector('.letter');
//       // Zufällige Richtung für Translation: 1 (nach unten) oder -1 (nach oben)
//       const moveDirection = Math.random() > 0.5 ? 1 : -1;
//       // Zufällige Richtung für Rotation: 1 (im Uhrzeigersinn) oder -1 (gegen Uhrzeigersinn)
//       const rotateDirection = Math.random() > 0.5 ? 1 : -1;
//       // Setze initiale Transformation auf 0
//       letter.style.transform = `translateY(0px) rotate(0deg)`;
//       return {
//         element: wrap,
//         letter, // Das span.letter-Element
//         moveDistance: 100 * moveDirection, // 100 Pixel für Bewegung
//         rotateAngle: 180 * rotateDirection, // 180 Grad für Rotation
//         speed: 0.03, // Einheitliche, niedrige Geschwindigkeit
//         currentMoveOffset: 0, // Aktuelle Translation
//         currentRotation: 0, // Aktuelle Rotation
//         wasInViewport: false // Verfolgt, ob der Buchstabe bereits im Viewport war
//       };
//     });
  
//     let lastScroll = window.pageYOffset;
//     let hasScrolled = false; // Verfolgt, ob ein Scroll-Event aufgetreten ist
  
//     function animateLetters() {
//       const currentScroll = window.pageYOffset;
//       const scrollDelta = currentScroll - lastScroll; // Positiv (runter) oder negativ (hoch)
  
//       // Markiere, dass ein Scroll-Event aufgetreten ist
//       if (scrollDelta !== 0) {
//         hasScrolled = true;
//       }
  
//       // Nur animieren, wenn gescrollt wurde
//       if (hasScrolled) {
//         letters.forEach(letter => {
//           const inViewport = isInViewport(letter.element);
//           // Setze auf Originalposition, wenn der Buchstabe den Viewport betritt
//           if (inViewport && !letter.wasInViewport) {
//             letter.currentMoveOffset = 0;
//             letter.currentRotation = 0;
//             letter.letter.style.transform = `translateY(0px) rotate(0deg)`;
//             letter.wasInViewport = true;
//           }
  
//           // Animieren, wenn das Element im Viewport ist
//           if (inViewport) {
//             // Bewegung und Rotation basierend auf Scroll-Delta
//             const moveIncrement = scrollDelta * letter.speed * Math.sign(letter.moveDistance);
//             const rotateIncrement = scrollDelta * letter.speed * Math.sign(letter.rotateAngle);
  
//             // Aktualisiere Position und Rotation
//             letter.currentMoveOffset += moveIncrement;
//             letter.currentRotation += rotateIncrement;
  
//             // Begrenze auf maximale Distanz/Rotation
//             letter.currentMoveOffset = Math.max(
//               Math.min(letter.currentMoveOffset, Math.abs(letter.moveDistance) * Math.sign(letter.moveDistance)),
//               -Math.abs(letter.moveDistance) * Math.sign(letter.moveDistance)
//             );
//             letter.currentRotation = Math.max(
//               Math.min(letter.currentRotation, Math.abs(letter.rotateAngle) * Math.sign(letter.rotateAngle)),
//               -Math.abs(letter.rotateAngle) * Math.sign(letter.rotateAngle)
//             );
  
//             // Transform nur auf span.letter anwenden
//             letter.letter.style.transform = `translateY(${letter.currentMoveOffset}px) rotate(${letter.currentRotation}deg)`;
//           }
//         });
//       }
  
//       lastScroll = currentScroll;
//       requestAnimationFrame(animateLetters);
//     }
  
//     // Animation starten
//     animateLetters();
//   });


import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener('DOMContentLoaded', () => {
  const letterWraps = document.querySelectorAll('.letter--wrap');

  letterWraps.forEach(wrap => {
    const letter = wrap.querySelector('.letter');

    const moveDirection = Math.random() > 0.5 ? 1 : -1;
    const rotateDirection = Math.random() > 0.5 ? 1 : -1;

    // Prüfen: Ist dieses letterWrap innerhalb von .cover?
    const isInCover = wrap.closest('.cover') !== null;

    if (isInCover) {
      // Buchstaben in .cover sollen beim Start UNBERÜHRT bleiben
      // Wir aktivieren die Animation erst nach dem ersten kleinen Scroll

      let scrollStarted = false;

      const onScroll = () => {
        if (!scrollStarted && window.scrollY > 10) {
          scrollStarted = true;
          window.removeEventListener('scroll', onScroll);

          // Animation jetzt aktivieren
          gsap.timeline({
            scrollTrigger: {
              trigger: wrap,
              start: "top bottom",
              end: "bottom top",
              scrub: true,
            }
          }).to(letter, {
            y: 100 * moveDirection,
            rotation: 180 * rotateDirection,
            ease: "none"
          });
        }
      };

      window.addEventListener('scroll', onScroll);

    } else {
      // Alle anderen letterWraps normal sofort mit ScrollTrigger verbinden
      gsap.timeline({
        scrollTrigger: {
          trigger: wrap,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
        }
      }).to(letter, {
        y: 100 * moveDirection,
        rotation: 180 * rotateDirection,
        ease: "none"
      });
    }
  });
});

